<template>
  <div>
    <canvas ref="canvasRef" :height="height" :width="width" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { fabric } from "fabric"

export default defineComponent({
  props: ['width', 'height', 'fCowHeight', 'mCowHeight'],
  data() {
    return {
      canvas: null,
    };
  },
  update() {
    this.initCanvas()
  },
  mounted() {
    this.initCanvas()
  },
  methods: {
    initCanvas() {
      if (!this.canvas) {
        this.canvas = new fabric.Canvas(this.$refs.canvasRef)
        this.canvas.selection = false
        this.canvas.preserveObjectStacking = true
      }
      // 描画内容を削除
      this.canvas.remove(...this.canvas.getObjects())
      // 定数値
      let lineWidth = 3
      let centerLineWidth = 41
      let centerLineOffset = 2
      let y1_offset = -9
      let y2_offset = 4
      let verticalOffset = 64
      let lineColor = "#C3C2C1"
      // 系統
      let startLineCenter = Math.floor(this.height / 2) - centerLineOffset
      let line = this.drawLine(0, startLineCenter, centerLineWidth, startLineCenter, lineWidth, lineColor)
      this.canvas.add(line)
      let startLineY1 = Math.floor(this.fCowHeight / 2) + y1_offset
      let startLineY2 = this.height - Math.floor((this.mCowHeight - verticalOffset) / 2) + y2_offset
      line = this.drawLine(centerLineWidth, startLineY1, centerLineWidth, startLineY2, lineWidth, lineColor)
      this.canvas.add(line)
      line = this.drawLine(centerLineWidth, startLineY1, this.width, startLineY1, lineWidth, lineColor)
      this.canvas.add(line)
      line = this.drawLine(centerLineWidth, startLineY2, this.width, startLineY2, lineWidth, lineColor)
      this.canvas.add(line)
    },
    drawLine(x1, y1, x2, y2, lineWidth, color) {
      const line = new fabric.Line(
        [x1, y1, x2, y2],
        {
          strokeWidth: lineWidth,
          stroke: color,
          selectable: false,
        }
      )
      return line
    },
  },
})
</script>

<style scoped></style>